import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import { parse } from 'query-string';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import mea from '../../services/mea';
import { routes } from '../../routes';
import { mapRoutes } from '../../utils/routeUtils';
import { getLocaleFromRoutes } from '../../services/i18n/utils';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';
import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { loginUser } from '../../services/authentication/login/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';
import { logoutUser } from '../../services/authentication/logout/actions';
import { MODAL_TYPE_REGISTER } from '../../services/modal/constants';
import { showModal } from '../../services/modal/actions';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);
        const { history, location } = this.props;

        if (sessionStorage.getItem('redirectAfterLogin')) {
            history.push(sessionStorage.getItem('redirectAfterLogin'));
            sessionStorage.removeItem('redirectAfterLogin');
        }

        const params = parse(location.search);
        if (params && params.peetvader) {
            sessionStorage.setItem('sponsor', params.peetvader);
            this.showRegisterModal();
        }
    }

    componentDidMount() {
        this.props.fetchPartnersIfNeeded();
        this.props.fetchCategoriesIfNeeded();
        this.props.fetchMeasIfNeeded(mea.constants.BOOSTED_OFFER_MEA_TYPE);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.changeCurrentLocaleIfNeeded(nextProps);
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, currentLocale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== currentLocale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    showRegisterModal = () => this.props.showModal(MODAL_TYPE_REGISTER);

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !_.isEmpty(state.authentication.token)
    };
};
const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchCategoriesIfNeeded,
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded,
    changeCurrentLocale,
    loginUser,
    logoutUser,
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js